import { render } from "./DownedBirdForm.vue?vue&type=template&id=639bdcc3&scoped=true"
import script from "./DownedBirdForm.vue?vue&type=script&lang=js"
export * from "./DownedBirdForm.vue?vue&type=script&lang=js"

import "./DownedBirdForm.vue?vue&type=style&index=0&id=639bdcc3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639bdcc3"]])

export default __exports__